<div fxFlex="100" fxLayoutAlign="center center">
  <div tabindex="1"></div>
  <div [class.width-100]="fullWidth" fxFlex="50" class="search-container">
    <div class="wrap" fxLayout="column" fxLayoutAlign="start start">
      <div class="header" *ngIf="label">
        <span class="search-label">{{ label }}</span>
      </div>

      <div class="search-input-results-container">
        <div class="result-count" *ngIf="isShowSearchResults && !isLoading && profilesList">
          {{ totalDocs }} résultats
        </div>
        <div class="search" (click)="showSearchResults($event)">
          <div class="icon">
            <mat-icon *ngIf="icon && iconType === 'mat-icon'">
              {{ icon }}
            </mat-icon>

            <img *ngIf="icon && iconType === 'image'" class="svg" [src]="icon" alt="" />
          </div>

          <input
            tabindex="2"
            #search
            (keyup)="onEnter(search.value)"
            type="text"
            class="searchTerm"
            [disabled]="disabled"
            [placeholder]="selectedProfile ? '' : placeholder"
          />

          <app-smart-op-avatar
            class="selected-profile"
            *ngIf="selectedProfile && !isShowSearchResults"
            [profile]="selectedProfile"
            [hidePosition]="true"
            [hideSpecialty]="true"
            [hideResendency]="true"
            [hideHospital]="true"
            [isImportProfile]="true"
          ></app-smart-op-avatar>

          @if (showClearButton && (search.value || selectedProfile)) {
            <mat-icon class="clear-icon" (click)="clearInput($event)"> close </mat-icon>
          }

          @if (isLoading) {
            <mat-spinner diameter="20" class="search-input-spinner"> </mat-spinner>
          }

          <mat-icon class="expand-icon" (click)="toggleSearchResults($event)">expand_more</mat-icon>
        </div>
        <div class="search-hint-message" *ngIf="hintMessage.length > 0">{{ hintMessage }}</div>

        <div class="search-results-container" [class.visible]="isShowSearchResults">
          <div class="height-100" fxLayout="column">
            @if (isLoading && profilesList.length === 0) {
              <div class="loading-container height-100" fxLayoutAlign="center center">
                <mat-spinner diameter="30"></mat-spinner>
              </div>
            }

            <cdk-virtual-scroll-viewport class="height-100" itemSize="38" (scrolledIndexChange)="onScroll($event)">
              <div *cdkVirtualFor="let profile of profilesList; let i = index">
                <div class="search-result-container arrow" (click)="profileClick(profile, $event)">
                  <app-smart-op-avatar [profile]="profile"></app-smart-op-avatar>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>

            @if (!isLoading && profilesList.length === 0) {
              <div class="no-results height-100" fxLayoutAlign="center center">Aucun résultat</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
